const VIEWS = {
    ALL: "ALL",
    SNAPSHOT: "SNAPSHOT",
    COMMUNICATIONS: "COMMUNICATIONS",
    DIAGNOSES: "DIAGNOSES",
    DIAGNOSTIC: "DIAGNOSTIC",
    PROBLEMS: "PROBLEMS",
    RECORDS: "RECORDS",
    NOTES: "NOTES",
    VITALS: "VITALS",
    REFILL_REQUEST: "REFILL_REQUEST",
    RECORDS_BUNDLE: "RECORDS_BUNDLE",
    ACTIVITIES: "ACTIVITIES",
    DECLINED_ITEMS: "DECLINED_ITEMS"
};

export default {
    VIEWS
};
